import { FavouriteItemType } from '@app/types'

export const TITLES = {
  customOdds: 'tip.customOdds',
  [FavouriteItemType.sport]: 'common.topSports',
}


export const POST_TIP_ACTIONS = [
  { id: 1, title: 'common.won' },
  { id: 2, title: 'common.lost' },
  { id: 3, title: 'common.void' },
]